<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout
            :meun="meunItem"
            :title="meunTitle"
            :title2="headTitle"
          ></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainTitle"></div>
          <el-tabs
            class="elTabs"
            v-model="activeName"
            @tab-click="handleClick"
            v-if="initDatas"
          >
            <el-tab-pane label="当然校友资料认证" name="0">
              <data-authentication-list></data-authentication-list>
            </el-tab-pane>
            <el-tab-pane label="注册校友资料认证" name="1">
              <register-authentication-list></register-authentication-list>
            </el-tab-pane>
            <el-tab-pane label="人脸认证" name="2">
              <face-authentication-list></face-authentication-list>
            </el-tab-pane>
            <el-tab-pane label="已认证校友" name="3">
              <activation-list></activation-list>
            </el-tab-pane>
          </el-tabs>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayoutWxapp";
import dataAuthenticationList from "@/components/authentication/dataAuthenticationList";
import registerAuthenticationList from "@/components/authentication/registerAuthenticationList";
import faceAuthenticationList from "@/components/authentication/faceAuthenticationList";
import activationList from "@/components/authentication/activationList";

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    dataAuthenticationList,
    registerAuthenticationList,
    faceAuthenticationList,
    activationList,
  },
  data() {
    return {
      meunItem: null,
      meunTitle: "",
      headTitle: "校友会名称",
      activeName: "0",
      initDatas: false,
    };
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem;
      this.meunTitle = meunItem.name;
      this.headTitle = this.$route.query.title;
      // if (localStorage.getItem(this.$route.path)) this.activeName = localStorage.getItem(this.$route.path)
      this.initDatas = true;
    },
    handleClick(tab, event) {
      // localStorage.setItem(this.$route.path, tab.name)
    },
  },
};
</script>

<style lang="less" scoped>
.mainTitle {
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  padding-bottom: 50px;
  margin-top: -40px;
  margin-left: -20px;
  margin-right: -20px;
}
.elTabs {
  margin-top: -40px;
}
</style>


// WEBPACK FOOTER //
// src/pages/wxapp/authentication.vue